import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { obterFeedbackCandidatura, enviarFeedbackCandidatura, marcarEtapaCandidatura } from "../services/api";

/**
 * Página do link direto de feedback: sem login, sem conta, três perguntas.
 *
 * Existe porque na empresa que não tem sistema integrado não há nada para ler — o único jeito de saber se ela
 * respondeu o candidato é perguntar ao candidato. Exigir login aqui mataria a resposta: a pessoa abre o e-mail no
 * celular e, se aparecer tela de senha, fecha. E o dado que a gente perde é justamente o que sustenta a cobrança.
 */
// ESTES TRÊS FICAM FORA DO COMPONENTE DE PROPÓSITO.
//
// Enquanto estavam declarados dentro de FeedbackCandidaturaPage, cada tecla digitada no comentário mudava o
// estado, a página re-renderizava e as três funções nasciam de novo, com identidade diferente. O React trata
// função nova como OUTRO tipo de componente: desmonta a árvore inteira e monta do zero. Na prática, o textarea
// era recriado a cada letra, perdia o foco e a página voltava para o topo — dava para digitar um caractere por
// vez, e ninguém termina um formulário assim. Movidas para o módulo, a identidade é estável entre renders.
// CABECALHO ENXUTO, SEM O MENU DO SITE.
//
// Aqui ficava o <Header /> completo, com navegacao e o botao "Entrar". Em 27/08/2026 vimos alguem abrir
// o formulario e ir direto para a tela de login, onde passou 41 segundos e desistiu: chegou para responder
// tres perguntas, viu um "Entrar" no topo e concluiu que precisava de conta. O e-mail promete "nao precisa
// criar conta" e o topo da pagina dizia o contrario.
//
// Esta pagina tem UMA tarefa. A marca leva ao site para quem quiser conhecer; nada mais compete com o
// formulario.
const Tela = ({ children }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b border-gray-200 bg-white">
      <div className="max-w-2xl mx-auto px-4 md:px-6 py-4">
        <a href="/" className="text-lg font-extrabold text-primary">eaiRH</a>
      </div>
    </header>
    <main className="max-w-2xl mx-auto px-4 md:px-6 py-10">{children}</main>
  </div>
);

// max-w-full + whitespace-normal: no celular (390px) "Nao, fiquei sem resposta" estourava a largura e o
// botao sumia na borda direita. Texto de botao aqui e frase, nao palavra — precisa poder quebrar linha.
const Botao = ({ ativo, onClick, children }) => (
  <button type="button" onClick={onClick}
    className={`max-w-full whitespace-normal text-left rounded-xl border px-4 py-2 text-sm font-semibold ${ativo
      ? "border-primary bg-primary text-white"
      : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"}`}>{children}</button>
);

// Reação a cada escolha. Um formulário que só registra cliques trata um momento difícil como papelada;
// uma frase curta depois da resposta mostra que tem gente do outro lado — e é ela que faz a pessoa
// continuar até a nota, em vez de fechar a aba no meio.
const Reacao = ({ tom = "neutro", children }) => {
  const cor = { bom: "border-green-200 bg-green-50 text-green-900",
                ruim: "border-amber-200 bg-amber-50 text-amber-900",
                neutro: "border-blue-200 bg-blue-50 text-blue-900" }[tom];
  return <p className={`mt-2 rounded-xl border px-3 py-2 text-sm ${cor}`}>{children}</p>;
};

export default function FeedbackCandidaturaPage() {
  const { token } = useParams();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [pronto, setPronto] = useState(false);
  // nota e voltaria alimentam a reputação da empresa; publicar é o consentimento para virar relato na página dela.
  // publicar nasce true porque é o que a pessoa espera ao responder ("isso vai servir para alguma coisa"), e a
  // caixa fica visível e desmarcável logo acima do botão — consentimento escondido não é consentimento.
  // ETAPA DECLARADA PELO CANDIDATO. Vem antes de tudo porque decide o que a tela pergunta depois: quem
  // parou na triagem não recebe pergunta de nota — num processo com 50 pessoas, 49 são descartadas por
  // definição, e avaliar isso mediria a frustração do descarte, não a qualidade do processo.
  const [etapa, setEtapa] = useState(null);
  const [salvandoEtapa, setSalvandoEtapa] = useState(false);
  const [f, setF] = useState({ houveRetorno: null, contratado: null, comentario: "",
                               nota: null, voltaria: null, publicar: true });

  useEffect(() => {
    obterFeedbackCandidatura(token)
      .then((d) => { setDados(d); if (d.respondido) setPronto(true); })
      .catch(() => setErro("Não encontramos esta candidatura. O link pode estar incompleto."));
  }, [token]);

  // QUEM AUTORIZA PUBLICAR PRECISA TER RESPONDIDO NOTA E "VOLTARIA".
  //
  // Sem nota, autorizar a publicacao nao publicava nada — e sem avisar: a pessoa marcava a caixa, enviava e
  // saia achando que tinha contribuido, enquanto o back so cria o relato quando existe nota.
  // Sem "voltaria" e pior: o back INFERE a resposta a partir da nota, e ai a pagina da empresa passa a exibir
  // uma opiniao que a pessoa nunca deu. Publicar em nome de alguem exige o que a pessoa de fato disse.
  const faltaResposta = f.publicar && (f.nota === null || f.voltaria === null);

  async function enviar() {
    if (faltaResposta) { setErro("Para publicar, responda a nota e se voltaria a se candidatar — ou desmarque a autorizacao."); return; }
    setErro(""); setEnviando(true);
    try { await enviarFeedbackCandidatura(token, f); setPronto(true); }
    catch (e) { setErro(e.message); } finally { setEnviando(false); }
  }

  // break-words: "O link pode estar incompleto" estourava a largura em 390px e a frase aparecia cortada
  // na borda — justo para quem chegou com um link truncado pelo cliente de e-mail e precisa ENTENDER isso.
  if (erro && !dados) return <Tela><p role="alert" className="text-red-600 break-words">{erro}</p></Tela>;
  if (!dados) return <Tela><p className="text-gray-500">Carregando...</p></Tela>;

  if (pronto)
    return (
      <Tela>
        <div className="rounded-2xl border border-green-200 bg-green-50 p-6">
          <h1 className="text-xl font-bold text-gray-900">Obrigado por contar.</h1>
          <p className="text-sm text-gray-700 mt-2">
            {dados.houveRetorno === false || f.houveRetorno === false
              ? "Vamos cobrar o retorno da empresa. Ninguém deveria ficar no vácuo depois de se candidatar."
              : "É assim que a gente sabe quais empresas tratam bem quem se candidata."}
          </p>
          {/* Dizer que a nota entrou fecha o ciclo: a pessoa clicou e viu que o clique teve consequência. */}
          {f.publicar && f.nota !== null && (
            <p className="text-sm text-gray-700 mt-2">
              Sua nota <b>{f.nota}</b> já entrou na reputação{dados.empresa ? <> da <b>{dados.empresa}</b></> : null}.
            </p>
          )}
          <div className="mt-4 flex flex-wrap gap-3">
            <Link to="/vagas" className="rounded-xl bg-primary hover:bg-brand text-white text-sm font-semibold px-4 py-2">Ver outras vagas</Link>
            {/* Quem acabou de contar que ficou sem resposta está no momento exato de registrar o relato: é a
                mesma história, e pedir de novo daqui a uma semana significa nunca mais. */}
            {(dados.houveRetorno === false || f.houveRetorno === false) && (
              <Link to="/denunciar" className="rounded-xl border border-primary text-primary text-sm font-semibold px-4 py-2 hover:bg-primary/5">
                Registrar como relato
              </Link>
            )}
          </div>
        </div>
      </Tela>
    );

  return (
    <Tela>
      <h1 className="text-2xl font-bold text-gray-900">
        {dados.nome ? <>Oi, {dados.nome}! Como foi o seu processo?</> : <>Como foi o seu processo?</>}
      </h1>
      <p className="text-gray-600 mt-1">
        Você se candidatou a <b>{dados.vaga}</b>{dados.empresa ? <> na <b>{dados.empresa}</b></> : null}.
      </p>

      {/* O "não precisa de senha" era uma linha cinza pequena, e perdia a disputa para o botão ENTRAR do
          cabeçalho — que é colorido e fica no topo. Em 27/08 uma pessoa abriu este link, foi direto para a
          tela de login, passou 47 segundos lá e não respondeu. Quem chega aqui vem de um e-mail nosso, não
          tem conta e não deveria precisar de uma: o aviso passa a ter o tamanho do mal-entendido. */}
      <p className="mt-3 rounded-xl border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-900">
        Não precisa criar conta nem fazer login. É só responder aqui embaixo.
      </p>

      <div className="mt-6 space-y-6">
        {/* PRIMEIRA PERGUNTA: em que pé está o processo.
            Antes a tela abria perguntando "a empresa deu retorno?" — pergunta boa para quem já teve desfecho e
            estranha para quem ainda espera. Marcar a etapa também é o que permite acompanhar processo onde não
            há ATS integrado, que é a maioria dos casos. */}
        <div>
          <p className="font-semibold text-gray-900 mb-2">Em que pé está esse processo?</p>
          <div className="flex flex-wrap gap-2">
            {[
              [0, "Ainda aguardando"],
              [1, "Não tive retorno"],
              [2, "Fui chamado para entrevista"],
              [3, "Já fiz a entrevista"],
              [4, "Recebi um não"],
              [5, "Fui contratado"],
            ].map(([v, rot]) => (
              <Botao key={v} ativo={etapa === v} onClick={async () => {
                setEtapa(v);
                setSalvandoEtapa(true);
                // Grava na hora: se a pessoa fechar a página aqui, o dado da etapa já valeu — e ele sozinho
                // alimenta o índice de resposta da empresa, mesmo sem o resto do formulário.
                try { await marcarEtapaCandidatura(token, v); } catch { /* segue: o envio final regrava */ }
                setSalvandoEtapa(false);
              }}>{rot}</Botao>
            ))}
          </div>
          {etapa === 5 && <Reacao tom="bom">Parabéns! Que venha o próximo capítulo.</Reacao>}
          {etapa === 1 && (
            <Reacao tom="ruim">
              Sentimos muito{dados.nome ? `, ${dados.nome}` : ""}. Vamos registrar isso na reputação da
              empresa — é assim que o silêncio deixa de sair de graça.
            </Reacao>
          )}
          {etapa === 2 && <Reacao tom="neutro">Boa sorte! Quando a entrevista acontecer, volte aqui e conte como foi.</Reacao>}
          {salvandoEtapa && <p className="mt-2 text-xs text-gray-400">salvando…</p>}
        </div>

        <div>
          <p className="font-semibold text-gray-900 mb-2">A empresa deu algum retorno?</p>
          <div className="flex flex-wrap gap-2">
            <Botao ativo={f.houveRetorno === true} onClick={() => setF({ ...f, houveRetorno: true })}>Sim, deram retorno</Botao>
            <Botao ativo={f.houveRetorno === false} onClick={() => setF({ ...f, houveRetorno: false, contratado: null })}>Não, fiquei sem resposta</Botao>
          </div>
          {f.houveRetorno === true && (
            <Reacao tom="bom">Que bom. Ainda é mais raro do que deveria — e por isso vale registrar.</Reacao>
          )}
          {f.houveRetorno === false && (
            <Reacao tom="ruim">
              Sentimos muito{dados.nome ? `, ${dados.nome}` : ""}. Ficar sem resposta é o que mais machuca em
              processo seletivo, e é justamente o que o eaiRH existe para mudar.
            </Reacao>
          )}
        </div>

        {/* Só faz sentido perguntar se houve retorno. Perguntar "foi contratado?" para quem acabou de dizer que
            ficou sem resposta é desatenção com quem está respondendo. */}
        {f.houveRetorno === true && (
          <div>
            <p className="font-semibold text-gray-900 mb-2">Você foi contratado?</p>
            <div className="flex flex-wrap gap-2">
              <Botao ativo={f.contratado === true} onClick={() => setF({ ...f, contratado: true })}>Sim, fui contratado</Botao>
              <Botao ativo={f.contratado === false} onClick={() => setF({ ...f, contratado: false })}>Não segui no processo</Botao>
            </div>
            {f.contratado === true && (
              <Reacao tom="bom">Parabéns! 🎉 Ficamos felizes de verdade — e o seu relato ajuda muito quem está tentando agora.</Reacao>
            )}
            {f.contratado === false && (
              <Reacao tom="neutro">
                Não foi dessa vez, mas você teve um retorno — e isso já coloca essa empresa acima da média.
                Continue tentando; seu currículo segue no ar por aqui.
              </Reacao>
            )}
          </div>
        )}

        {/* A NOTA é o que faz esta resposta contar na reputação da empresa: a fórmula pesa nota e "voltaria".
            Sem ela, o feedback fica registrado e não move nada — e empresa que trata bem continua sem ganhar
            por isso. Fica opcional para não travar quem só quer dizer que ficou sem resposta.

            SÓ APARECE DEPOIS DA PRIMEIRA RESPOSTA. O convite prometeu "três perguntas"; com nota, "voltaria",
            comentário e consentimento abertos de saída, quem abria via seis blocos e adiava — e adiar, numa
            pesquisa, é o mesmo que não responder. Quem já clicou uma vez continua; a tela cresce com a pessoa
            dentro, em vez de assustar na porta. */}
        {f.houveRetorno !== null && (
        <div>
          <p className="font-semibold text-gray-900 mb-2">
            Que nota você dá para esse processo? <span className="font-normal text-gray-500 text-sm">(0 a 10)</span>
          </p>
          <div className="flex flex-wrap gap-1.5">
            {Array.from({ length: 11 }, (_, n) => (
              <button key={n} type="button" onClick={() => setF({ ...f, nota: n })}
                aria-pressed={f.nota === n}
                className={`w-10 h-10 rounded-lg border text-sm font-semibold ${f.nota === n
                  ? "border-primary bg-primary text-white"
                  : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"}`}>{n}</button>
            ))}
          </div>
          <p className="text-xs text-gray-500 mt-2">
            É a nota que entra na reputação da empresa aqui no eaiRH.
          </p>
          {f.nota !== null && f.nota <= 4 && (
            <Reacao tom="ruim">Obrigado pela sinceridade. Nota baixa registrada é o que faz uma empresa olhar para o próprio processo.</Reacao>
          )}
          {f.nota !== null && f.nota >= 5 && f.nota <= 7 && (
            <Reacao tom="neutro">Anotado. O “mais ou menos” também é informação — mostra onde dá para melhorar sem precisar mudar tudo.</Reacao>
          )}
          {f.nota !== null && f.nota >= 8 && (
            <Reacao tom="bom">Ótimo saber. Empresa que trata bem quem se candidata merece aparecer por isso.</Reacao>
          )}
        </div>
        )}

        {f.nota !== null && (
          <div>
            <p className="font-semibold text-gray-900 mb-2">Você voltaria a se candidatar nessa empresa?</p>
            <div className="flex flex-wrap gap-2">
              <Botao ativo={f.voltaria === true} onClick={() => setF({ ...f, voltaria: true })}>Sim, voltaria</Botao>
              <Botao ativo={f.voltaria === false} onClick={() => setF({ ...f, voltaria: false })}>Não voltaria</Botao>
            </div>
          </div>
        )}

        {f.houveRetorno !== null && (
          <div>
            <p className="font-semibold text-gray-900 mb-2">Quer contar como foi? <span className="font-normal text-gray-500 text-sm">(opcional)</span></p>
            <textarea rows="4" maxLength={4000} value={f.comentario}
              onChange={(e) => setF({ ...f, comentario: e.target.value })}
              placeholder="O que funcionou, o que poderia ser melhor, quanto tempo demorou..."
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-primary outline-none" />
          </div>
        )}

        {/* Consentimento de publicar. Só aparece quando há nota, porque só aí existe algo a publicar — mostrar a
            caixa antes seria pedir autorização para uma coisa que não vai acontecer. */}
        {f.nota !== null && (
          <label className="flex gap-3 items-start rounded-xl border border-gray-200 bg-gray-50 p-4 cursor-pointer">
            <input type="checkbox" checked={f.publicar} className="mt-0.5"
              onChange={(e) => setF({ ...f, publicar: e.target.checked })} />
            <span className="text-sm text-gray-700">
              Pode publicar isso na página da <b>{dados.empresa || "empresa"}</b>, sem o meu nome.
              <span className="block text-gray-500 mt-0.5">
                É assim que a sua experiência ajuda quem vai se candidatar depois de você — e é o que faz uma
                empresa que dá retorno ganhar por isso.
              </span>
            </span>
          </label>
        )}

        {erro && <p role="alert" className="text-sm text-red-600">{erro}</p>}

        <button type="button" onClick={enviar} disabled={enviando || f.houveRetorno === null || faltaResposta}
          className="rounded-xl bg-primary hover:bg-brand disabled:opacity-60 text-white font-semibold px-6 py-2.5">
          {enviando ? "Enviando..." : "Enviar"}
        </button>
        {f.houveRetorno === null && <p className="text-xs text-gray-400">Responda a primeira pergunta para enviar.</p>}
        {/* O aviso so aparece DEPOIS que a pessoa comecou. Ele nasceu aparecendo de cara — porque a
            autorizacao de publicar ja vem marcada e a nota comeca vazia — e mandava "escolha uma nota acima"
            apontando para uma escala que ainda nem estava na tela. Erro antes de errar afasta. */}
        {faltaResposta && f.houveRetorno !== null && (
          <p className="text-xs text-amber-700">
            {f.nota === null
              ? "Escolha uma nota de 0 a 10 acima."
              : "Responda se voltaria a se candidatar nessa empresa."}{" "}
            E o que vai para a pagina da empresa, entao precisa ser o que voce respondeu — se preferir nao
            avaliar, desmarque a autorizacao e a sua resposta e registrada do mesmo jeito.
          </p>
        )}
      </div>
    </Tela>
  );
}
